import React from 'react';
import { Button, Col, Container, Form, Image, Row, Table } from 'react-bootstrap';
import Select from 'react-select';
import { LoaderComponente } from "../../Components/LoaderComponente";
import { NavBarComponente } from '../../Components/NavBarComponente';
import "../../Estilo/Form.css";
import baixo from '../../Imagens/arrow-down-blue-16.png';
import voltar from '../../Imagens/arrow-left-16.png';
import voltarInicio from '../../Imagens/arrow-left-first-16.png';
import proximo from '../../Imagens/arrow-right-16.png';
import proximoUltimo from '../../Imagens/arrow-right-last-16.png';
import cima from '../../Imagens/arrow-up-blue-16.png';
import clearFilter from '../../Imagens/clear-filter.png';
import fechar from '../../Imagens/close-24.png';
import filtrar from '../../Imagens/filter-16.png';
import printer from '../../Imagens/printer.png';
import { FormEvent } from '../../ScreenGeneric/Models/FormEvent';
import { TypePagination } from '../TableGeneric/TableGenericViewController';
import { LogRelatoryViewModel } from './LogRelatoryViewModel';
import { GlobalViewModel } from '../Global/GlobalViewModel';
import { InputModalSelectComponent } from '../../Components/InputModalSelectComponent';
import moment from 'moment';

interface MyProps {
    navigation: any
    delegate: LogRelatory
    viewModel: LogRelatoryViewModel
}

export interface LogRelatory {
    tapDimiss(navigation: any): void
}
export interface Filters {
    userId: string,
    data_from: string,
    data_to: string,
    hour_from: string,
    hour_to: string,
    pagina: number;
}

export class LogRelatoryViewController extends React.Component<MyProps> {

    private globalViewModel = new GlobalViewModel()
    private formEvent: FormEvent
    state = {
        isLoading: true,
        json: {},
        data: Array<any>(),
        total: 0,
        personList: Array<any>(),
        clearValue: false,
        showFilter: false,
        filters: ({
            userId: '',
            data_from: '',
            data_to: '',
            hour_from: '',
            hour_to: '',
            pagina: 1
        }),
        countPage: 1
    }

    constructor(props: any) {
        super(props)
        this.formEvent = new FormEvent(this)
    }

    componentDidMount() {
        this.loadData()
        this.setState({
            isLoading: false
        })
    }

    render() {
        return (
            <div>
                <NavBarComponente propNav={this.props.navigation} />
                <div>
                    <Container fluid={true}>
                        <Row>
                            <Col>
                                <div className="title">
                                    <h3>Relatório de Log</h3>
                                </div>
                                <div className="buttonClose">
                                    <Image className="imageClose"
                                        onClick={(e: any) => this.props.delegate.tapDimiss(this.props.navigation)}
                                        src={fechar} />
                                </div>
                            </Col>
                        </Row>
                        <Form className="containerForm">
                            <Row className="header">
                                <Col xs="12" className="infoFilter">
                                    <h3 onClick={() => this.setState({ showFilter: !this.state.showFilter })}>
                                        <Image
                                            className="iconFilter"
                                            src={this.state.showFilter ? cima : baixo} />
                                        EXIBIR FILTROS
                                    </h3>
                                </Col>
                                {this.state.showFilter &&
                                    <Col xs="12" className="containerFilter">
                                        <Form>
                                            <Row>
                                                <Col lg="5"></Col>
                                                <Col lg="4">Data</Col>
                                                <Col lg="3">Hora</Col>
                                            </Row>
                                            <Row>
                                                <Col lg="4" xs="12" className="bottom10">
                                                    <Form.Label>Usuário</Form.Label>
                                                    <Select
                                                        id="cusuario"
                                                        value={this.state.filters.userId ? this.formEvent.onValueSelect('select', 'camada', this.state.personList) : null}
                                                        onChange={(e: any) => this.verifyFilters('userId', e ? e.value : null)}
                                                        closeMenuOnSelect={true}
                                                        placeholder={"Selecione"}
                                                        options={this.state.personList}
                                                    />
                                                </Col>
                                                <Col lg="2" xs="12" className="bottom10">
                                                    <Form.Label>De</Form.Label>
                                                    <Form.Control
                                                        id="hour_from"
                                                        type="time"
                                                        value={this.state.filters.hour_from}
                                                        onChange={(e: any) => this.verifyFilters('hour_from', e.target.value)}
                                                        placeholder="Digite..." />
                                                </Col>
                                                <Col lg="2" xs="12" className="bottom10">
                                                    <Form.Label>Até</Form.Label>
                                                    <Form.Control
                                                        id="hour_to"
                                                        type="time"
                                                        value={this.state.filters.hour_to}
                                                        onChange={(e: any) => this.verifyFilters('hour_to', e.target.value)}
                                                        placeholder="Digite..." />
                                                </Col>
                                                <Col lg="2" xs="12" className="bottom10">
                                                    <Form.Label>De</Form.Label>
                                                    <Form.Control
                                                        id="data_from"
                                                        type="date"
                                                        value={this.state.filters.data_from}
                                                        onChange={(e: any) => this.verifyFilters('data_from', e.target.value)}
                                                        placeholder="Digite..." />
                                                </Col>
                                                <Col lg="2" xs="12" className="bottom10">
                                                    <Form.Label>Até</Form.Label>
                                                    <Form.Control
                                                        id="data_to"
                                                        type="date"
                                                        value={this.state.filters.data_to}
                                                        onChange={(e: any) => this.verifyFilters('data_to', e.target.value)}
                                                        placeholder="Digite..." />
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col xs='12'>
                                                    <Button
                                                        onClick={() => this.screenUpdate()}
                                                        variant="info"
                                                        type="button"
                                                        className="btnFilter right10">
                                                        <Image
                                                            className="iconBtnFilter"
                                                            src={filtrar} />
                                                        Filtrar
                                                    </Button>
                                                    <Button
                                                        onClick={() => {
                                                            this.clearFilters()
                                                            this.setState({
                                                                clearValue: true
                                                            })
                                                        }}
                                                        variant="info"
                                                        type="button"
                                                        className="btnFilter">
                                                        <Image
                                                            className="iconBtnFilter"
                                                            src={clearFilter} />
                                                        Limpar
                                                    </Button>
                                                </Col>
                                            </Row>
                                        </Form>
                                    </Col>
                                }

                                <Col xs="12" className='mt-2'>
                                    <Button variant="danger" type="button" className="buttonGeneric colorRed"
                                        onClick={() => this.printRelatory(this.state.filters)}>
                                        <Image
                                            className="iconButtonGeneric"
                                            src={printer} />
                                        PDF
                                    </Button>
                                </Col>
                            </Row>
                            <>
                                <Table responsive hover style={{ textAlign: 'left', fontSize: 14, backgroundColor: "#ffffff" }}>
                                    <thead style={{ backgroundColor: "#eeeeee" }}>
                                        <tr>
                                            <th>Sequencial</th>
                                            <th>Usuário</th>
                                            <th>Descrição</th>
                                            <th>Data</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.state.data && this.state.data.map((item, key) => (
                                            <tr key={key}>
                                                <td>{item.id}</td>
                                                <td>{item.nome}</td>
                                                <td>{item.descricao}</td>
                                                <td>{moment(item.hora, 'HH:mm:ss').format('HH:mm:ss')} {moment(item.data).format('DD/MM/YYYY')}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </Table>
                                <div style={{ borderWidth: 1, borderStyle: "solid", borderColor: "#cccccc", backgroundColor: "#eeeeee" }}>
                                    <Container fluid={true}>
                                        <Row>
                                            <Col xs="12">
                                                <div style={{ height: 30 }}>
                                                    <div style={{ float: "right" }}>
                                                        <label style={{ marginLeft: 10, fontSize: 12, fontWeight: "bold" }}>Número de Registros: {this.state.total}</label>
                                                    </div>
                                                    {this.state.data.length ? (
                                                        <div style={{ float: "left" }}>
                                                            {this.state.filters.pagina != 1 && (
                                                                <>
                                                                    <Image
                                                                        style={{ marginLeft: 0, cursor: "pointer" }}
                                                                        src={voltarInicio}
                                                                        onClick={() => this.pagination('first')}
                                                                        width={16}
                                                                        className="center"
                                                                        fluid />
                                                                    <Image
                                                                        style={{ marginLeft: 10, cursor: "pointer" }}
                                                                        src={voltar}
                                                                        onClick={() => this.pagination('back')}
                                                                        width={16}
                                                                        className="center"
                                                                        fluid />
                                                                </>
                                                            )}
                                                            <label className="tablePage">{this.state.filters.pagina}/{this.state.countPage}</label>
                                                            {this.state.filters.pagina !== this.state.countPage && (
                                                                <>
                                                                    <Image
                                                                        style={{ marginLeft: 10, cursor: "pointer" }}
                                                                        src={proximo}
                                                                        onClick={() => this.pagination('next')}
                                                                        width={16}
                                                                        className="center"
                                                                        fluid />
                                                                    <Image
                                                                        style={{ marginLeft: 10, cursor: "pointer" }}
                                                                        src={proximoUltimo}
                                                                        onClick={() => this.pagination('last')}
                                                                        width={16}
                                                                        className="center"
                                                                        fluid />
                                                                </>
                                                            )}
                                                        </div>
                                                    ) : <label className="tablePage">0/{this.state.countPage}</label>}
                                                </div>
                                            </Col>
                                        </Row>
                                    </Container>
                                </div>
                            </>
                        </Form>
                    </Container>
                </div>
                <LoaderComponente show={this.state.isLoading} hide={() => this.setState({ isLoading: this.state.isLoading })} />
            </div>
        )
    }

    private printRelatory(filters: any) {
        this.setState({
            isLoading: true
        })

        this.props.viewModel.fetchLogsRelatory(filters).then((data) => {
            this.setState({
                isLoading: false
            })
        })

    }

    private loadData() {
        this.screenUpdate()
        this.lists()

    }

    private screenUpdate() {
        this.setState({ isLoading: true })
        this.props.viewModel.fetchLogs(this.state.filters).then((response: any) => {
            if (response.length) {
                this.setState({
                    isLoading: false,
                    data: response,
                    countPage: Math.ceil(response[0].total / 10),
                    total: Number(response[0].total)
                })
            } else {
                this.setState({
                    isLoading: false,
                    data: response,
                    countPage: 0,
                    total: 0
                })
            }
        })
    }

    private lists() {
        this.globalViewModel.fetchDataToSelectInput('usuario', 'cusuario').then((response: any) => {
            if (response.length) {
                this.setState({
                    personList: response
                })
            }
        })
    }

    private verifyFilters(key: keyof Filters, newValue: string) {
        let newFilters = this.state.filters as any;
        newFilters[key] = newValue;
        if (key !== 'pagina') newFilters['pagina'] = 1;
        this.setState({
            filters: newFilters
        });
    }

    private async pagination(type: TypePagination) {
        var page
        switch (type) {
            case 'first':
                page = 1
                break;
            case 'back':
                page = this.state.filters.pagina - 1
                break;
            case 'next':
                page = this.state.filters.pagina + 1
                break;
            case 'last':
                page = this.state.countPage
                break;
        }
        await this.setState({
            filters: {
                ...this.state.filters,
                pagina: page
            }
        })
        this.screenUpdate()
    }

    private async clearFilters() {
        await this.setState({
            filters: {
                userId: '',
                data_from: '',
                data_to: '',
                hour_from: '',
                hour_to: '',
                pagina: 1
            }
        })
        this.screenUpdate()
    }
}